import httpClient from '../utils/httpClient';

const API = '/employee-document';

export const uploadDocument = async (data) => httpClient.post(API, data);
export const getDocumentsByEmployee = async (employeeId) => httpClient.get(`${API}/employee/${employeeId}`);
export const getExpiringDocuments = async (days = 30) => httpClient.get(`${API}/expiring?days=${days}`);
export const getDocument = async (id) => httpClient.get(`${API}/${id}`);
export const downloadDocument = async (id) => {
  const baseUrl = process.env.REACT_APP_BASE_URL || '';
  const token = localStorage.getItem('token');
  const res = await fetch(`${baseUrl}${API}/${id}/download`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.blob();
};
export const updateDocument = async (id, data) => httpClient.put(`${API}/${id}`, data);
export const deleteDocument = async (id) => httpClient.delete(`${API}/${id}`);
